export const SocialActionTypes = {
  SET_SOCIAL_FIND: "SET_SOCIAL_FIND",
  SET_SOCIAL_HIST: "SET_SOCIAL_HIST",
  SET_SOCIAL_SESS: "SET_SOCIAL_SESS",
  SET_SOCIAL_VIEW: "SET_SOCIAL_VIEW"
};
